import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  constructor(private http: HttpClient) {}

  forgotPassword(email: string, lang: string): Observable<any> {
    const data = {
      email: email,
      lang: lang,
    };
    return this.http.post(environment.apiURL + 'auth/forgotPassword', data);
  }
}